import React from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { Iconfont } from "../../../../../../../components/icon/iconfont";
import { FormattedMessage } from "react-intl";


export default props =>{
    useStyles(cls);

    return <div className={cls.OrderListEmpty}>
        <div>
            <Iconfont className={cls.Icon}>&#xe6d8;</Iconfont>
        </div>

        <p className={cls.Title}><FormattedMessage id="you_have_no_orders" defaultMessage="You don't have any orders yet, go pick your favorite products!" /></p>
    
        <a href={`/`} className={cls.LinkBtn}><FormattedMessage id="go_shopping" defaultMessage="Go Shopping" /></a>
    </div>
}